<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="height: 100%; position: relative; display: flex; flex-direction: column;" class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="center" :style="{'background-color': $store.state.colors.primary}">
                <v-img max-width="230px" src="@/assets/resources/yoomi/yoomy-blanco.png"></v-img>
            </v-row>
            <v-row justify="center" align="center" style="background-color: orange; color: white">
                <v-col class="ml-8 mt-0 pt-1">
                    <v-row >
                        Bienvenid@
                    </v-row>
                    <v-row style="font-size: 10px; ">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Phasellus lobortis est a faucibus feugiat.
                    </v-row>
                </v-col>
            </v-row>

            <!-- New content -->
            <v-row style="height: 100%;" >
                <v-col>
                    
                </v-col>
            </v-row>
            <!-- Button Continue -->
            
        <v-row justify="center" align="center" style="width: 100%; position: absolute; left: 0px; bottom: 5px; margin: 0 auto;" class="pt-0">
            <br><br><br>
            <v-btn class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 90%; height: 55px; margin: 15px; ">
                <span style="float: left; padding-left:0px;">Continuar</span>
                <v-spacer></v-spacer>
                <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
            </v-btn>
        </v-row>
            

        </v-col>
    </v-row>
</template>


<script>
export default {
    created() {
            this.$store.state.logo = false;
        }
}
</script>

<style scoped>

</style>